import { Stack } from '@mui/material';
import { AgronodTypography } from '@agronod/mui-components';
import { MATT_STATUS_TEXT, MattStatus } from '../../utils/api';
import { StatusCell } from './StatusCell';

const ORDNING: MattStatus[] = ['over', 'under', 'inom', 'saknas'];

/** Förklaring av måttsymbolerna i revisionens tabeller. */
export const StatusForklaring = () => (
  <Stack
    direction="row"
    spacing={3}
    useFlexGap
    sx={{ flexWrap: 'wrap', alignItems: 'center' }}
  >
    {ORDNING.map((status) => (
      <Stack key={status} direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <StatusCell status={status} />
        <AgronodTypography variant="body2" sx={{ color: 'text.secondary' }}>
          {MATT_STATUS_TEXT[status]}
        </AgronodTypography>
      </Stack>
    ))}
  </Stack>
);

/** Rubrik över en tabell med valfri metatext till höger. */
export const SektionRubrik = ({
  titel,
  meta,
  nedtonad = false,
}: {
  titel: string;
  meta?: string;
  /** Rubriken i sekundär färg – för listan över gårdar utanför revisionen. */
  nedtonad?: boolean;
}) => (
  <Stack
    direction="row"
    useFlexGap
    sx={{
      alignItems: 'baseline',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 2,
      mb: 1,
    }}
  >
    <AgronodTypography
      variant="h6"
      component="h2"
      sx={{ color: nedtonad ? 'text.secondary' : undefined }}
    >
      {titel}
    </AgronodTypography>
    {meta && (
      <AgronodTypography variant="body2" sx={{ color: 'text.secondary' }}>
        {meta}
      </AgronodTypography>
    )}
  </Stack>
);

/** Fotnot om intervallen i kolumnrubrikerna. */
export const IntervallFotnot = () => (
  <AgronodTypography variant="caption" sx={{ color: 'text.secondary', maxWidth: 720 }}>
    Intervallen under varje kolumnrubrik visar urvalsgränserna för respektive
    nyckeltal. ”max” innebär att endast en övre gräns finns, ”min” endast en
    undre.
  </AgronodTypography>
);
